import { render, staticRenderFns } from "./ProjetStatut.vue?vue&type=template&id=6edd82a0&"
import script from "./ProjetStatut.vue?vue&type=script&lang=js&"
export * from "./ProjetStatut.vue?vue&type=script&lang=js&"
import style0 from "./ProjetStatut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports